import DeviceFrame from '@components/DeviceFrame';

import type { ICreativeFrameProps } from './types';

const CreativeFrame = ({ deviceType, imageSrc, containerRef, className, sharedScale }: ICreativeFrameProps) => {
  return (
    <div className={className}>
      <DeviceFrame
        deviceType={deviceType}
        containerRef={containerRef}
        imageSrc={imageSrc}
        sharedScale={sharedScale}
      />
    </div>
  );
};

export default CreativeFrame;
